import { Component, Input, OnInit } from '@angular/core';
import { ErrorStateService, RegistrationStepService, StepType, TermsAndConditionsType } from '@fgb/core';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'fgb-registration-terms-and-conditions',
  templateUrl: './registration-terms-and-conditions.component.html',
  styleUrls: ['./registration-terms-and-conditions.component.scss'],
})
export class RegistrationTermsAndConditionsComponent implements OnInit {
  @Input() ShouldSkip: boolean = false;
  termsAndConditionsType = TermsAndConditionsType;
  readonly stepType = StepType.TermsAndConditions;
  accepted: boolean = false;

  constructor(private registrationStepService: RegistrationStepService, public registrationStepQuery: ErrorStateService) {}

  isLoaded = false;

  async ngOnInit(): Promise<void> {
    const result = await lastValueFrom(this.registrationStepService.fetchRegistrationStepForCurrentWizard(this.stepType, true));
    this.ShouldSkip = result.ShouldSkip;
    this.isLoaded = true;
  }

  submitStep() {
    this.registrationStepService
      .submitRegistrationStepData(this.stepType, { Accepted: this.accepted, TermsAndConditions: null })
      .toPromise();
  }
}
